import { useParams } from 'react-router-dom';

export const useWasteId = () => useParams<Dictionary<string>>().id!;
